<ng-template #contentDashboard>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
            (click)="modalRef.dismiss('Cross click')" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span class="title" i18n="parameters-style|@@editDashboard">Ajouter ou supprimer des colonnes du
            Dashboard</span>
        </div>
      </div>
      <div class="row p-0 m-0">
        <div class="col-12">
          <div class="table-option">
            <div class="container">
              <div class="row center firstRow">
                <div class="col-6">
                  <span class="titleRow" i18n="parameters-style|@@inactive">Inactif</span>
                </div>
                <div class="col-6">
                  <span class="titleRow" i18n="parameters-style|@@active">Actif</span>
                </div>
              </div>
              <div class="dndPlaceholder col-12" #placeholder></div>
              <div class="row">
                <div class="col-6">
                  <div class="col-12 listContainer p-0 m-0" [dndList] [dndPlaceholder]="placeholder"
                    [dndModel]="dashboardList[1]">
                    <div *ngFor="let item of dashboardList[1]" class="col-12 element" [dndType]="'item'"
                      (dndMoved)="removeItem(item, dashboardList[1])" [dndDraggable] [dndObject]="item">{{item.display}}
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="col-12  element fix"><span i18n="parameters-style|@@readNotRead">Lu / Non Lu</span></div>
                  <div class="col-12 listContainer p-0 m-0" [dndList] [dndModel]="dashboardList[2]"
                    [dndPlaceholder]="placeholder">
                    <div *ngFor="let item of dashboardList[2]" class="col-12 element" [dndType]="'item'"
                      (dndMoved)="removeItem(item, dashboardList[2])" [dndDraggable] [dndObject]="item">{{item.display}}
                    </div>
                  </div>
                  <div class="col-12  element fix" i18n="parameters-style|@@actionComponent">Volet d'Actions</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer ">
    <div class="alignL">
      <button type="button" class="btn btn-lg secondary" (click)="resetDashboard()">
        <span class="text-span" i18n="parameters-style|@@reset">Reset</span>
      </button>
      <button type="button" class="btn btn-lg primary longSubmit" (click)="modalRef.close('Save click')"
        i18n="parameters-style|@@confirm">Valider</button>
    </div>
  </div>
</ng-template>

<div class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="parameters-style|@@customStyle">Style Personnalisé</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12 report-form">
      <span class="column-title" i18n="parameters-style|@@Home-Dashboard">Accueil - Dashboard</span>
      <div class="container">
        <div class="row generalrows">
          <div class="col-5 center">
            <span class="span-txt" i18n="parameters-style|@@editArray">Modifier le tableau</span>
          </div>
          <div class="col-7 alignR">
            <button type="button" class="btn btn-lg secondary" (click)="openModal('dashboard')">
              <span class="text-span" i18n="parameters-style|@@addingDeletingColumns">Ajouter ou supprimer des
                colonnes</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 report-form">
      <span class="column-title" i18n="parameters-style|@@damages">Dommages</span>
      <div class="container">
        <div class="row generalrows">
          <div class="col-5 center">
            <span class="span-txt" i18n="parameters-style|@@autoDamagesColor">Couleur des dommages automatiques</span>
          </div>
          <div class="col-2">
            <input [(colorPicker)]="damageColor" [style.background]="damageColor" [cpPosition]="'bottom'"
              [cpPositionOffset]="'8%'" [cpPositionRelativeToArrow]="true" [cpAlphaChannel]="'disabled'"
              (colorPickerChange)="changeColor($event)" />
          </div>
        </div>
        <div class="row generalrows">
          <div class="col-5 center">
            <span class="span-txt" i18n="parameters-style|@@manualDamagesColor">Couleur des dommages manuels</span>
          </div>
          <div class="col-2">
            <input [(colorPicker)]="newDamageColor" [style.background]="newDamageColor" [cpPosition]="'bottom'"
              [cpPositionOffset]="'8%'" [cpPositionRelativeToArrow]="true" [cpAlphaChannel]="'disabled'"
              (colorPickerChange)="changeColor($event)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-style/parameters-style.component.html